import type { RootState } from '../reducers';

export const getProductListSortVisible = (state: RootState) => state.events.productListSortVisible;

export const getPipeMessage = (state: RootState) => state.events.lastPipeMessage;
